<style lang="sass" scoped>
    .input_search_ctn
        position: relative
        display: inline-block
        padding: 0 25px 0 15px
        width: 240px
        height: 30px
        border-radius: 30px
        border: 1px solid #E9E9E9
        > i
            position: absolute
            top: 6px
            right: 16px
            cursor: pointer

        ::v-deep .el-input
            input
                height: 28px
                border: none
                background: transparent
                padding-left: 0
</style>

<template lang='pug'>
.input_search_ctn
  el-input(
      ref="input" v-model="keyword" clearable
      :placeholder="placeholder || '请输入关键字'"
      @change="searchChange"
      @keyup.enter.native="search"
  )
  i.el-icon-search(@click="search")
</template>

<script>

export default {
    name: 'InputSearch',
    props: ['clearSearch', 'placeholder'],
    data () {
        return {
            keyword: '',
            resultVisible: false,
            hoverIndex: -1
        }
    },
    watch: {
        keyword (v) {
            if (v == '' && this.clearSearch) this.search()
        }
    },
    methods: {
        searchChange(val) {
            val = val.replace(/\s*/g, '')
            this.keyword = val
        },
        search () {
            this.$emit('search', this.keyword.trim())
        }
    }
}
</script>
